import React from 'react';
import FirmwareAssignmentState from './firmwareAssignmentState/FirmwareAssignmentState';
import FirmwareSection from './components/FirmwareSection/FirmwareSection';
import RestaurantsSection from './components/RestaurantsSection/RestaurantsSection';
import { ModalWindows } from './components/ModalWindows';
import style from './index.module.scss';

const FirmwareAssignmentPage: React.FC = () => {
	return (
		<FirmwareAssignmentState>
			<div className={style.container}>
				<FirmwareSection />
				<RestaurantsSection />
			</div>
			<ModalWindows />
		</FirmwareAssignmentState>
	);
};

export default FirmwareAssignmentPage;
